import { fetchConfig } from '@jky/utilities';
import { CartLinesUpdateEvent, CartErrorEvent } from '@shopify/events';
import { Component } from '@jky/component';

export class JkyAddToCartComponent extends Component {
  requiredRefs = ['addToCartButton', 'spinner'];
  connectedCallback() {
    super.connectedCallback();
    this.url = this.dataset.url;
    this.id = parseInt(this.dataset.id);
    this.quantity = parseInt(this.dataset.quantity);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
  }

  disable() {
    this.refs.addToCartButton.disabled = true;
    this.refs.addToCartButton.classList.add('pointer-events-none');
  }

  enable() {
    this.refs.addToCartButton.disabled = false;
    this.refs.addToCartButton.classList.remove('pointer-events-none');
  }

  handleClick(event) {
    event.preventDefault();
    this.disable();
    this.handleLoading();
    const deferredEventPromise = CartLinesUpdateEvent.createPromise();
    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [
          { merchandiseId: this.id, quantity: this.quantity }
        ],
        promise: deferredEventPromise.promise,
      })
    );

    const body = {
        id: this.id,
        quantity: this.quantity,
        sections_url: window.location.pathname,
        sections: ''
    }

    const jkycarts = document.querySelectorAll('jky-cart');
    let jkyCartSectionIds = [];
    jkycarts.forEach(item => {
      if (item instanceof HTMLElement && item.sectionId) {
        jkyCartSectionIds.push(item.sectionId);
      }
      body.sections = jkyCartSectionIds.join(',');
    });

    fetch(this.url, fetchConfig('json', { body: JSON.stringify(body) }))
        .then(res => res.json())
        .then(async (response) => {
            if (response.status) {
                this.dispatchEvent(
                    new CartErrorEvent({
                        error: response.message || 'jky-add-to-cart: Add to cart failed',
                        code: 'INVALID',
                        detail: {
                            description: response.description,
                            errors: response.errors
                        }
                    })
                );

                // 刷新购物车数据
                this.#refreshCart()
                    .then((ajaxCart) =>
                        deferredEventPromise.resolve({
                            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
                            detail: {
                                didError: true,
                                items: ajaxCart.items,
                                source: 'product-form-component',
                                sourceId: this.id.toString(),
                                itemCount,
                                productId: this.dataset.productId
                            }
                        })
                    )
                    .catch(deferredEventPromise.reject);

                pushErrorMessage && pushErrorMessage(response.message || 'Add to cart failed');
                // 尝试刷新购物车数据 refreshCart
                this.handleErrorRefreshCart();
                return;
            } else {
                const cart = await this.#refreshCart()
                    .then((ajaxCart) => {
                        deferredEventPromise.resolve({
                            cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart),
                            detail: {
                                items: ajaxCart.items,
                                source: 'jky-add-to-cart',
                                sourceId: this.id.toString(),
                                itemCount: this.quantity,
                                productId: this.dataset.productId,
                                sections: response.sections,
                                didError: false
                            }
                        });
                        return ajaxCart;
                    })
                    .catch(deferredEventPromise.reject);
            }
        })
        .catch(error => {
            console.error('jky-add-to-cart Error:', error);
        })
        .finally(() => {
            this.enable();
            this.resetLoading();
        })
  }

  async #refreshCart() {
    const jkyCart = document.querySelector('jky-cart');

    if (jkyCart) {
      await customElements.whenDefined('jky-cart');
      return jkyCart.fetchCartData();
    }

    // 没有jky-cart元素，使用路由获取购物车数据
    return fetch(`${this.dataset.routesCartUrl}.json`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then((response) => {
      if (!response.ok) throw new Error(`Failed to fetch cart: ${response.status}`);
      return response.json();
    });
  }
  handleErrorRefreshCart() {
    const jkyCart = document.querySelector('jky-cart');
    if (jkyCart) {
      jkyCart.refreshCart();
    }
  }

  handleLoading() {
    this.refs.spinner.classList.remove('opacity-0');
    this.refs.addToCartButton.querySelector('span').classList.add('opacity-0');
  }
  resetLoading() {
    this.refs.spinner.classList.add('opacity-0');
    this.refs.addToCartButton.querySelector('span').classList.remove('opacity-0');
  }
}

if (!customElements.get('jky-add-to-cart')) {
  customElements.define('jky-add-to-cart', JkyAddToCartComponent);
}